function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#150e60;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 307.91,
  y1: 172.05,
  x2: 338.82,
  y2: 166.6,
  gradientTransform: "translate(195.85 -288.52) rotate(90)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d31509"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#d92531"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#de3254"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#e33d70"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#e64583"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#e7498f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#e84b93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#e7498d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#e5427c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#e03760"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#da2839"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d31509"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M23.77,51.21c-6.34,0-11.48-7.1-11.48-15.85s5.14-15.84,11.48-15.84c2.37,0,9,2.71,11.49,2.71,10,0-2,6.32-2,13.13s11.61,12.2,2.89,12.2C33.14,47.56,26.55,51.21,23.77,51.21Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M56.93,51.21c0-8.89-2.72-15.09-11.6-15.09-10.22,0-13.68,15.09-22.76,15.09Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M56.93,19.52c0,8.89-2.72,15.09-11.6,15.09-10.22,0-13.68-15.09-22.76-15.09Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.8869601d.svg";
export { ForwardRef as ReactComponent };